module.exports = __webpack_public_path__ + "static/media/IMG_8050.736b8ccd.JPG";